import $api from "../http";
import { IReservationsParams } from "../api/types";
import { IClassEventReservation } from "../models/ClassEventReservation";
import dayjs from "dayjs";

class ClassEventReservationServiceClass {
  getAll(model: IReservationsParams) {
    let query = `?fromDate=${dayjs(model.from).format("YYYY-MM-DD")}&toDate=${dayjs(model.to).format("YYYY-MM-DD")}`;
    if (model.searchValue) {
      query += `&searchValue=${model.searchValue}`;
    }
    if (model.userId) {
      query += `&userId=${model.userId}`;
    }
    return $api.get<IClassEventReservation[]>(`api/class-event/reservation/all${query}`);
  }

  cancel(reservationId: number, gymListingId: string) {
    return $api.delete<{}>(`api/class-event/reservation/cancel/${reservationId}`, {
      data: { gymListingId },
    });
  }
}

export const ClassEventReservationService = new ClassEventReservationServiceClass();
